import React, {useState} from 'react';
import {Box, Collapse, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';
import {CARD_SX, Eyebrow} from '../interventions/v2/primitives.js';
import {useGetErreurQuery} from '../../../modules/simulations/simulations.api';
import {lignesEtalons, medianesEtalons} from './sensibiliteRules';

const ENTETES = ['Période', 'Journées réelles / simulées', 'Bacs', 'Coût réel', 'Coût simulé', 'Erreur', 'Erreur calibrée'];

/** Bloc « Étalons » repliable du récap : un épisode par ligne et les médianes, recopiés de `GET /simulations/erreur` (aucun recalcul) ; absent sans épisode. */
function BlocEtalons({patrimoineId}) {
    const [ouvert, setOuvert] = useState(false);
    const {data: erreur} = useGetErreurQuery(String(patrimoineId), {skip: !patrimoineId});
    const lignes = lignesEtalons(erreur);
    if (lignes.length === 0) return null;
    return (
        <Box sx={{...CARD_SX, p: 2}} data-testid="etalons">
            <Eyebrow sx={{cursor: 'pointer'}} onClick={() => setOuvert((o) => !o)}>{ouvert ? '▾' : '▸'} Étalons · {lignes.length} {lignes.length >= 2 ? 'épisodes' : 'épisode'}</Eyebrow>
            <Collapse in={ouvert} unmountOnExit>
                <TableContainer component={Paper} variant="outlined" sx={{mt: 1}}>
                    <Table size="small" aria-label="étalons">
                        <TableHead><TableRow>{ENTETES.map((h) => <TableCell key={h} align={h === 'Période' ? 'left' : 'right'}>{h}</TableCell>)}</TableRow></TableHead>
                        <TableBody>
                            {lignes.map((l) => (
                                <TableRow key={l.cle} data-testid="etalon" data-incomplet={l.incomplet} sx={l.incomplet ? {opacity: 0.5} : undefined}>
                                    <TableCell>{l.periode}{l.couverture && <Typography variant="caption" sx={{display: 'block'}}>{l.couverture} · hors médianes</Typography>}</TableCell>
                                    <TableCell align="right">{l.journees}</TableCell>
                                    <TableCell align="right">{l.bacs}</TableCell>
                                    <TableCell align="right">{l.coutReel}</TableCell>
                                    <TableCell align="right">{l.coutSimule}</TableCell>
                                    <TableCell align="right">{l.erreur}</TableCell>
                                    <TableCell align="right">{l.erreurCalibre}</TableCell>
                                </TableRow>
                            ))}
                            {medianesEtalons(erreur).map((m) => (
                                <TableRow key={m.cle} data-testid="etalon-mediane">
                                    <TableCell colSpan={5} sx={{fontWeight: 700}}>{m.libelle} ({m.n})</TableCell>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{m.erreur}</TableCell>
                                    <TableCell align="right" sx={{fontWeight: 700}}>{m.erreurCalibre}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Collapse>
        </Box>
    );
}

export default BlocEtalons;
